import { error } from "toastr"
import {
  CREATE_INSURANCENEED_START,
  CREATE_INSURANCENEED_SUCCESS,
  CREATE_INSURANCENEED_FAILURE,
  CREATE_INSURANCENEED_RESET,
  GET_INSURANCENEED_START,
  GET_INSURANCENEED_SUCCESS,
  GET_INSURANCENEED_FAILURE,
  GET_INSURANCENEED_RESET,
  GET_INCOME_START,
  GET_INCOME_SUCCESS,
  GET_INCOME_FAILURE,
  GET_INCOME_RESET,
  DELETE_INSURANCE_NEED_FAILURE,
  DELETE_INSURANCE_NEED_RESET,
  DELETE_INSURANCE_NEED_START,
  DELETE_INSURANCE_NEED_SUCCESS,
  UPDATE_INSURANCE_NEED,
  UPDATE_INSURANCE_NEED_SUCCESS,
  UPDATE_INSURANCE_NEED_FAILED,
} from "./actiontypes"

const initialState = {
  error: null,
  responseMsg: null,
  loading: false,
  insuranceneed: [],
  income: [],
  isDeleted: false,
}

const InsuranceNeedReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_INSURANCENEED_START:
      return {
        ...state,
        error: null,
        responseMsg: "",
        loading: true,
      }
    case CREATE_INSURANCENEED_SUCCESS:
      return {
        ...state,
        loading: false,
        responseMsg: action.payload.message,
        insuranceneed: action.payload,
      }
    case CREATE_INSURANCENEED_FAILURE:
      return {
        ...state,
        error: action.error.message,
        loading: false,
        responseMsg: "",
      }

    case CREATE_INSURANCENEED_RESET:
      return {
        insuranceneed: [],
        error: null,
        loading: false,
        responseMsg: "",
      }

    case GET_INSURANCENEED_START:
      return {
        ...state,
        loading: true,
        error: null,
        responseMsg: "",
        insuranceneed:[],
      }

    case GET_INSURANCENEED_SUCCESS:
      return {
        ...state,
        loading: false,
        insuranceneed: action.payload.data,
      }

    case GET_INSURANCENEED_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }
    case GET_INSURANCENEED_RESET:
      return {
        insuranceneed: [],
        error: null,
        loading: false,
      }

    case GET_INCOME_START:
      return {
        ...state,
        loading: true,
        error: null,
        responseMsg: "",
      }

    case GET_INCOME_SUCCESS:
      return {
        ...state,
        loading: false,
        income: action.payload.data,
      }

    case GET_INCOME_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }
    case GET_INCOME_RESET:
      return {
        income: [],
        error: null,
        loading: false,
      }
    // Delete API

    case DELETE_INSURANCE_NEED_START:
      return {
        ...state,
        loading: true,
      }

    case DELETE_INSURANCE_NEED_SUCCESS:
      return {
        ...state,
        loading: false,
        isDeleted: true,
      }
    case DELETE_INSURANCE_NEED_FAILURE:
      return {
        ...state,
        loading: false,
        isDeleted: false,
      }
    case DELETE_INSURANCE_NEED_RESET:
      return {
        ...state,
        loading: false,
        isDeleted: false,
      }
    case UPDATE_INSURANCE_NEED:
      return{
        ...state,
        loading: true
      }
    case UPDATE_INSURANCE_NEED_SUCCESS:
      return{
        ...state,
        loading: false,
        responseMsg: action.payload
      }
    case UPDATE_INSURANCE_NEED_FAILED:
      return{
        ...state,
        loading: false,
        error: action.payload
      }

    default:
      return state
  }
}

export default InsuranceNeedReducer
